export default {
  openingHours: {
    monday: {
      when: 'Always',
    },
    tuesday: {
      when: 'Always',
    },
    wednesday: {
      when: 'Always',
    },
    thursday: {
      when: 'Always',
    },
    friday: {
      when: 'Always',
    },
    saturday: {
      when: 'Always',
    },
    sunday: {
      when: 'Always',
    },
  },
  adminFeePolicy: { chargeTypeName: 'None' },
  serviceChargeTypeName: 'Fixed',
  serviceChargeValue: 0,
  vATTreatmentTypeName: 'None',
  applyPrivateDriverPolicy: false,
  applyFullCoveragePolicy: false,
  minimumTimeRequiredForBooking: 10,
}
